import React from 'react'
import BlogHero from './components/Banner'
import BlogList from './components/BlogList'

const BlogMain = () => {
  return (
    <div className=''>
      <BlogHero />
      <BlogList />
    </div>
  )
}

export default BlogMain
